module.exports = __webpack_public_path__ + "img/OHLogo.d6f81bd2.png";